export default __webpack_public_path__ + "static/media/arrow-right-green.db7b0b35.svg";